import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { OneOffIncomePaymentModel } from '../../Models/Models/Processes/Drawdown/OneOffIncomePaymentModel';
import { DrawdownSinglePaymentInstruction } from '../../Models/Domains/Drawdown/DrawdownSinglePaymentInstruction';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownSinglePaymentInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, drawdownSinglePaymentInstruction: DrawdownSinglePaymentInstruction): Promise<OneOffIncomePaymentModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownSinglePaymentInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, drawdownSinglePaymentInstruction: drawdownSinglePaymentInstruction }

    return AjaxWrapper.post<OneOffIncomePaymentModel, any>(url, data);
  }
}

